import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { ZeroMatchingLeaseInquiresRoutes  } from '../../../routes';

export const ZeroMatchingLeaseInquiresLayout = () => <SwitchRoute routes={ZeroMatchingLeaseInquiresRoutes} />;
